import { assetAdditionalData, relatedApi } from '../api';

/**
 * @param {string} vendor
 * @param {number} assetId
 * @param {number | undefined} limit
 * @returns {Promise<>}
 */
async function getRelatedAssets({ vendor, assetId, limit }) {
    const query = [`additional=${assetAdditionalData}`];
    if (limit) {
        query.push(`limit=${limit}`);
    }

    return relatedApi({ path: `${vendor}/${assetId}`, query: query.join('&') });
}

export default {
    getRelatedAssets
};
